import React from 'react';
import EquipmentLoanPolicyContent from '../components/EquipmentLoanPolicyContent';

/**
 * Minimal policy view for embedding in an iframe (no site chrome).
 */
export default function EquipmentLoanPolicyEmbed() {
  return (
    <div className="min-h-full bg-white dark:bg-gray-900 text-primary-900 dark:text-gray-100 px-4 py-5 sm:px-6">
      <h1 className="text-lg font-serif font-semibold text-primary-900 dark:text-white border-b border-primary-200 dark:border-gray-600 pb-2 mb-4">
        Equipment Loan Policy &amp; Terms of Agreement
      </h1>
      <EquipmentLoanPolicyContent />
    </div>
  );
}
